export const settingsActions = {
  LOAD_SETTINGS_LIST: 'LOAD_SETTINGS_LIST',
  LOAD_SETTINGS_LIST_SUCCESS: 'LOAD_SETTINGS_LIST_SUCCESS',
  LOAD_SETTINGS_LIST_FAIL: 'LOAD_SETTINGS_LIST_FAIL',

  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  UPDATE_SETTINGS_SUCCESS: 'UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_FAIL: 'UPDATE_SETTINGS_FAIL',

  loadSettingsList: () => ({
    type: settingsActions.LOAD_SETTINGS_LIST,
  }),

  loadSettingsListSuccess: data => ({
    type: settingsActions.LOAD_SETTINGS_LIST_SUCCESS,
    payload: { data },
  }),

  loadSettingsListFail: error => ({
    type: settingsActions.LOAD_SETTINGS_LIST_FAIL,
    payload: { error },
  }),

  updateSettings: (settingsId, settings) => ({
    type: settingsActions.UPDATE_SETTINGS,
    payload: { settingsId, settings },
  }),

  updateSettingsSuccess: () => ({
    type: settingsActions.UPDATE_SETTINGS_SUCCESS,
  }),

  updateSettingsFail: error => ({
    type: settingsActions.UPDATE_SETTINGS_FAIL,
    payload: { error },
  }),
};
